// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"836":"19004489","916":"83cfde4d"}[chunkId] + ".chunk.js";
};